"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerkleDistributorStubErrors = exports.MerkleDistributorStubJSON = void 0;
const anchor_contrib_1 = require("@saberhq/anchor-contrib");
exports.MerkleDistributorStubJSON = {
    version: "0.0.0",
    name: "merkle_distributor_stub",
    instructions: [
        {
            name: "claim",
            accounts: [
                {
                    name: "distributor",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "claimStatus",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "from",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "to",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "claimant",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
                {
                    name: "index",
                    type: "u64",
                },
                {
                    name: "amount",
                    type: "u64",
                },
                {
                    name: "proof",
                    type: {
                        vec: {
                            array: ["u8", 32],
                        },
                    },
                },
            ],
        },
    ],
    accounts: [
        {
            name: "MerkleDistributor",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "base",
                        type: "publicKey",
                    },
                    {
                        name: "bump",
                        type: "u8",
                    },
                    {
                        name: "root",
                        type: {
                            array: ["u8", 32],
                        },
                    },
                    {
                        name: "mint",
                        type: "publicKey",
                    },
                    {
                        name: "maxTotalClaim",
                        type: "u64",
                    },
                    {
                        name: "maxNumNodes",
                        type: "u64",
                    },
                    {
                        name: "totalAmountClaimed",
                        type: "u64",
                    },
                    {
                        name: "numNodesClaimed",
                        type: "u64",
                    },
                ],
            },
        },
    ],
};
exports.MerkleDistributorStubErrors = (0, anchor_contrib_1.generateErrorMap)(exports.MerkleDistributorStubJSON);
//# sourceMappingURL=merkle_distributor_stub.js.map